import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modules/modals';
import {closeModal} from '../../../reducers/modules/actions';
import { AnimatePresence, motion } from 'framer-motion';

import FacebookPost from './facebook-post';
import FacebookStory from './facebook-story';

export const ModalContainer = ({children}) => {
    return (
        <div className="modules-modal-container">
            {children}
        </div>
    )
}

export const ModalOverlay = () => {
    const dispatch = useDispatch();

    return (
        <motion.div
            className="modules-modal-overlay"
            onClick={() => dispatch(closeModal())}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
        />
    )
}

export const Modal = ({
    children
}) => {
    return (
        <ModalContainer>
            <ModalOverlay />

            <motion.div
                className="modules-modal"
                initial={{
                    opacity: 0,
                    y: 40
                }}
                animate={{
                    opacity: 1,
                    y: 0
                }}
                exit={{
                    opacity: 0,
                    y: 40
                }}
                transition={{
                    duration: 0.25,
                    ease: 'easeOut'
                }}
            >
                {children}
            </motion.div>
        </ModalContainer>
    )
}

export default () => {
    const {modals} = useSelector(Selector);


    return (
        <AnimatePresence>
            {modals.map((modal, key) => {
                if(modal.key === 'facebook_post') return <FacebookPost key={`${modal.key}-${key}`} modal={modal.key} data={modal.data} index={key} />
                if(modal.key === 'facebook_story') return <FacebookStory key={`${modal.key}-${key}`} modal={modal.key} data={modal.data} index={key} />
            })}
        </AnimatePresence> 
    )
}